import React from 'react'
import PropTypes from 'prop-types'
import {PERMISSION_GROUP_FORMER_USER, PERMISSION_GROUP_SUPER_ADMIN, PERMISSION_GROUP_VENDOR} from '../../constants/ModelConstants'
import SelectInput from '../SelectInput'
import {convertKeyLabelMapIntoSelectOptions} from '../../Utils/objectUtil'
import {CATEGORY_USER_TYPE} from './SettingsConstants'
function SelectStaffUserType(props) {
  const isEditingASuperAdminOrFormerUser = !props.isNewUser && (props.value === PERMISSION_GROUP_SUPER_ADMIN || props.isDisabled)
  const isNotEditable = isEditingASuperAdminOrFormerUser || [PERMISSION_GROUP_SUPER_ADMIN, PERMISSION_GROUP_VENDOR].includes(props.value)

  let selectUserTypeOptions =
    props.isNewUser || (!props.isNewUser && props.value !== PERMISSION_GROUP_SUPER_ADMIN && !props.isDisabled)
      ? convertKeyLabelMapIntoSelectOptions(CATEGORY_USER_TYPE).filter(
          option => option.value !== PERMISSION_GROUP_SUPER_ADMIN && option.value !== PERMISSION_GROUP_FORMER_USER,
        )
      : !props.isNewUser && props.isDisabled
      ? convertKeyLabelMapIntoSelectOptions(CATEGORY_USER_TYPE).filter(option => option.value !== PERMISSION_GROUP_SUPER_ADMIN)
      : !props.isNewUser && props.value === PERMISSION_GROUP_SUPER_ADMIN
      ? convertKeyLabelMapIntoSelectOptions(CATEGORY_USER_TYPE).filter(option => option.value !== PERMISSION_GROUP_FORMER_USER)
      : convertKeyLabelMapIntoSelectOptions(CATEGORY_USER_TYPE).filter(
          option => option.value !== PERMISSION_GROUP_SUPER_ADMIN && option.value !== PERMISSION_GROUP_FORMER_USER,
        )

  // Exclude types from dropdown if excludeTypes prop is provided
  if (props.excludeTypes && Array.isArray(props.excludeTypes) && props.excludeTypes.length > 0) {
    selectUserTypeOptions = selectUserTypeOptions.filter(option => !props.excludeTypes.includes(option.label))
  }

  return (
    <SelectInput
      label={'User Type'}
      value={props.isDisabled ? PERMISSION_GROUP_FORMER_USER : props.value}
      onChange={props.onChange}
      options={selectUserTypeOptions}
      error={props.error}
      disabled={isNotEditable || props.isEditingSelfGlobalAdmin}
      helperText={props.helperText}
    />
  )
}

SelectStaffUserType.propTypes = {
  isNewUser: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isEditingSelfGlobalAdmin: PropTypes.bool,
  excludeTypes: PropTypes.array,
  helperText: PropTypes.string,
}

export default SelectStaffUserType
